"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled = __importStar(require("./styled"));
const svg_components_1 = require("../../../assets/svg-components");
const useDebounce_1 = __importDefault(require("../../../Hooks/useDebounce"));
const SelectDropdown_1 = __importDefault(require("../SelectDropdown/SelectDropdown"));
const Utils_1 = require("../../../Utils");
const ONCHANGE_DELAY = 500;
const OPTIONS_AMOUNT = 20;
const AmountController = ({ quantity, setQuantity, maxWidth, minWidth, onChange, packageSize, warning, setWarning, disabled, }) => {
    const [amount, setAmount] = (0, react_1.useState)(quantity || 1);
    const [multipleAmount, setMultipleAmount] = (0, react_1.useState)();
    const [options, setOptions] = (0, react_1.useState)([]);
    const [firstRender, setFirstRender] = (0, react_1.useState)(true);
    const debouncedAmount = (0, useDebounce_1.default)(amount, ONCHANGE_DELAY);
    (0, react_1.useEffect)(() => {
        if (!firstRender) {
            if (typeof onChange === 'function' && amount !== quantity) {
                onChange(amount);
            }
        }
        setFirstRender(false);
    }, [debouncedAmount]);
    (0, react_1.useEffect)(() => {
        if (typeof setQuantity === 'function') {
            setQuantity(amount);
        }
    }, [amount]);
    (0, react_1.useEffect)(() => {
        if (packageSize > 1) {
            const newOptions = [];
            for (let index = 1; index <= OPTIONS_AMOUNT; index++) {
                const newSize = packageSize * index;
                newOptions.push({ id: index, name: newSize.toString() });
                newSize === quantity && setMultipleAmount({ id: index, name: newSize.toString() });
            }
            setOptions(newOptions);
        }
        else {
            setAmount(quantity || 1);
        }
    }, [quantity, packageSize]);
    (0, react_1.useEffect)(() => {
        if (typeof setQuantity === 'function' && multipleAmount) {
            setWarning('');
            setQuantity(parseInt(multipleAmount.name));
        }
    }, [multipleAmount]);
    const onInputChange = (e) => {
        const value = e.currentTarget.value;
        if (disabled || value === 'Infinity')
            return;
        if ((0, Utils_1.isNum)(value)) {
            if (+value === 0) {
                setAmount(1);
                return;
            }
            if (value[0] === '-') {
                setAmount(+value.substring(1, value.length));
                return;
            }
            if (value[value.length - 1] === '.') {
                return;
            }
            setAmount(+value);
        }
    };
    return (react_1.default.createElement(styled.Container, { maxWidth: maxWidth, minWidth: minWidth }, packageSize > 1 && options && multipleAmount ? (react_1.default.createElement(styled.DropdownContainer, null,
        react_1.default.createElement(SelectDropdown_1.default, { options: options, value: multipleAmount, setValue: setMultipleAmount, allowInput: true, error: !!warning }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styled.LeftButton, { onClick: () => setAmount(prev => (prev === 1 ? 1 : prev - 1)) },
            react_1.default.createElement(svg_components_1.SimpleMinus, null)),
        amount && react_1.default.createElement(styled.Amount, { value: amount, onChange: onInputChange, maxLength: 10 }),
        react_1.default.createElement(styled.RightButton, { onClick: () => setAmount(prev => prev + 1) },
            react_1.default.createElement(svg_components_1.SimplePlus, null))))));
};
exports.default = AmountController;
